import { BlueprintInstanceType } from '@rta/rta-blueprint-library';

import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const addSpacerMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Add Space Reservation',
		isVisible: ({ controller: { readonly }}): boolean => {
			return !readonly;
		},
		onClick: ({ context, position, refMap, controller }): void => {
			const isCountertop = controller.navigation.panelId === null;
			let targetId = context.id;

			// Resolve panel ID from countertop context
			if (refMap?.type === BlueprintInstanceType.Countertop && refMap?.countertop) {
				const islandId = refMap.countertop.islandIds?.[0];
				if (islandId) {
					const island = controller.kitchen?.design?.islands?.findById(islandId);
					if (island) {
						targetId = island.panels.frontPanelId;
					}
				}
			}

			controller.publishRequestedAction('add_spacer', targetId, {
				position,
				isCountertop
			});
		}
	};
};
